import { createSharedComposable } from '@vueuse/core'

export const useAddress = createSharedComposable(() => {
  const showAddressDialog = ref(false)

  return {
    showAddressDialog
  }
})
